import {match, Pattern} from 'ts-pattern';

/**
 * Maps legacy DMS `body_style` values (`BODY_*`) to v2 `car_style` values
 * (`CARSTYLE_*`). DMS occasionally already passes `CARSTYLE_*` directly — those
 * are passed through unchanged. Unknown values return `undefined` so the
 * caller can omit `car_style` from the payload (the backend treats missing
 * values as missing-bin rather than rejecting them).
 *
 * Extend `BODY_TO_CAR_STYLE` whenever a new DMS body-style value surfaces.
 */
const BODY_TO_CAR_STYLE: Record<string, string> = {
  BODY_HATCHBACK: 'CARSTYLE_HATCHBACK',
  BODY_SEDAN: 'CARSTYLE_SEDANS_SALOONS',
  BODY_LIMOUSINE: 'CARSTYLE_SEDANS_SALOONS',
  BODY_COMBI: 'CARSTYLE_ESTATE_CAR',
  BODY_ESTATE: 'CARSTYLE_ESTATE_CAR',
  BODY_SUV: 'CARSTYLE_SUV_OFFROAD',
  BODY_OFFROAD: 'CARSTYLE_SUV_OFFROAD',
  BODY_COUPE: 'CARSTYLE_COUPE',
  BODY_CABRIOLET: 'CARSTYLE_CABRIOLET',
  BODY_CONVERTIBLE: 'CARSTYLE_CABRIOLET',
  BODY_MPV: 'CARSTYLE_MPV',
  BODY_MINIVAN: 'CARSTYLE_MPV',
  BODY_VAN: 'CARSTYLE_VAN',
  BODY_PICKUP: 'CARSTYLE_PICK_UP',
  BODY_PICK_UP: 'CARSTYLE_PICK_UP',
};

const CAR_STYLE_PREFIX = 'CARSTYLE_';

export function mapBodyStyleToCarStyle(bodyStyle: string | null | undefined): string | undefined {
  return match(bodyStyle)
    .with(Pattern.nullish, () => undefined)
    .with('', () => undefined)
    .when(
      (value): value is string => typeof value === 'string' && value.startsWith(CAR_STYLE_PREFIX),
      // Pass-through: DMS already provides CARSTYLE_* in many flows.
      (value) => value
    )
    .otherwise((value) => BODY_TO_CAR_STYLE[value]);
}
